// extracted by mini-css-extract-plugin
export default {"dowloadButton":"style_dowloadButton__Tby8E"};